import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { Document } from '@roc/feature-types';

import { ScopeOfWorkV2FormExternalDialog } from '@roc/feature-sow-v2';
import { useDrawsStore } from '../hooks';
import { useBaseStore } from '@roc/feature-app-core';
import { useRocInternalPortalStore } from 'apps/roc-internal-portal/src/app/hooks';

interface RevisedScopeOfWorkFormDialogProps {
  open: boolean;
  onClose: () => void;
  document: Document;
}

export const RevisedScopeOfWorkFormDialog = observer(({ open, onClose, document }: RevisedScopeOfWorkFormDialogProps) => {

  const { globalStore } = useBaseStore();
  const isInternal = globalStore.isInternalPortal;

  if (!open) {
    return null;
  }

  if (isInternal) {
    return <ScopeOfWorkRevisionInternal open={open} drawId={document.drawId} onClose={onClose} document={document} />
  }

  return <ScopeOfWorkRevisionExternal open={open} document={document} onClose={onClose} />
});


export const ScopeOfWorkRevisionInternal = observer(({ open, drawId, onClose, document }) => {
  const { scopeOfWorkReviewInternalStore } = useRocInternalPortalStore();
  const { scopeOfWorkV2FormStore } = scopeOfWorkReviewInternalStore;
  const taskId = document?.taskId;

  useEffect(() => {
    return () => {
      scopeOfWorkReviewInternalStore.reset();
    };
  }, [scopeOfWorkReviewInternalStore]);

  useEffect(() => {
    scopeOfWorkReviewInternalStore.drawId = drawId;
    scopeOfWorkReviewInternalStore.fetchSOWRevision(drawId);
    return () => {
      scopeOfWorkReviewInternalStore.reset();
    };
  }, []);

  return (
    <ScopeOfWorkV2FormExternalDialog
      open={open}
      onClose={onClose}
      store={scopeOfWorkV2FormStore}
      title={'Scope Of Work Revision'}
      taskId={taskId}
    />
  );
});


export const ScopeOfWorkRevisionExternal = observer(({ open, document, onClose }) => {
  const { scopeOfWorkRevisionStore } = useDrawsStore();
  const scopeOfWorkRevisionFormStore = scopeOfWorkRevisionStore.scopeOfWorkV2FormStore;

  useEffect(() => {
    return () => {
      scopeOfWorkRevisionStore.reset();
    };
  }, [scopeOfWorkRevisionStore]);

  useEffect(() => {
    scopeOfWorkRevisionStore.fetchSOWRevision(document);
    return () => {
      scopeOfWorkRevisionStore.reset();
    };
  }, []);

  return (
    <ScopeOfWorkV2FormExternalDialog
      open={open}
      onClose={onClose}
      store={scopeOfWorkRevisionFormStore}
      title={'Scope Of Work Revision'}
    />
  );
});